

export const user = {
    id: null,
    name: null,
    email: null,
    master: false,
    can_view_users_pass: false,

    insert: function (data) {
        this.id = data?.id ?? null;
        this.name = data?.name ?? null;
        this.email = data?.email ?? null;
        this.master = data?.master ?? false;
        this.can_view_users_pass = data?.can_view_users_pass ?? false;
    }
}